module.exports = __webpack_public_path__ + "static/media/06-01.64c93c6e.png";